import SearchService from "@/services/SearchService";
import router from "@/router";

const getDefaultState = () => ({
  name: "",
  group: "",
  geo: {
    country: "",
    region: "",
    district: "",
    village: "",
  },
  loading: false,
  error: false,
  studentSearchResults: [],
  schoolSearchResults: [],
  primarySchoolSearchResults: [],
  teacherSearchResults: [],
  studentGroupSearchResults: [],
  teacherGroupSearchResults: [],
});

const searches = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    name(state, val) {
      state.name = val;
    },
    group(state, val) {
      state.group = val;
    },
    country(state, val) {
      state.geo.country = val;
    },
    region(state, val) {
      state.geo.region = val;
    },
    district(state, val) {
      state.geo.district = val;
    },
    village(state, val) {
      state.geo.village = val;
    },
    error(state, val) {
      state.error = val;
    },
    studentSearchResults(state, val) {
      state.studentSearchResults = val;
    },
    teacherSearchResults(state, val) {
      state.teacherSearchResults = val;
    },
    schoolSearchResults(state, val) {
      state.schoolSearchResults = val;
    },
    primarySchoolSearchResults(state, val) {
      state.primarySchoolSearchResults = val;
    },
    studentGroupSearchResults(state, val) {
      state.studentSearchResults = val;
    },
    teacherGroupSearchResults(state, val) {
      state.teacherSearchResults = val;
    },
    resetSearch(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async GET_STUDENTS_BY_LOCATION({ state, commit }) {
      state.error = false;
      state.loading = true;
      const table = "students";
      const res = await SearchService.searchGeo(
        table,
        state.searches.geo
      ).catch((err) => {
        console.log(err);
        state.loading = false;
        state.error = true;
      });
      const data = await res.data.results;
      commit("studentSearchResults", data);
      state.loading = false;
    },
    async GET_TEACHERS_BY_LOCATION({ state, commit }) {
      state.error = false;
      state.loading = true;
      const table = "teachers";
      const res = await SearchService.searchGeo(
        table,
        state.searches.geo
      ).catch((err) => {
        console.log(err);
        state.loading = false;
        state.error = true;
      });
      const data = await res.data.results;
      commit("teacherSearchResults", data);
      state.loading = false;
    },
    async GET_SCHOOLS_BY_LOCATION({ state, commit }) {
      state.error = false;
      state.loading = true;
      const table = "schools";
      const res = await SearchService.searchGeo(
        table,
        state.searches.geo
      ).catch((err) => {
        console.log(err);
        state.loading = false;
        state.error = true;
      });
      const data = await res.data.results;
      commit("schoolSearchResults", data);
      state.loading = false;
    },
    async GET_STUDENTS_BY_NAME({ state, commit }) {
      state.error = false;
      state.loading = true;
      const table = "students";
      const res = await SearchService.searchName(table, state.name).catch(
        (err) => {
          console.log(err);
          state.loading = false;
          state.error = true;
        }
      );
      const data = await res.data.results;
      console.log(data);
      commit("studentSearchResults", data);
      state.loading = false;
    },
    async GET_TEACHERS_BY_NAME({ state, commit }) {
      state.error = false;
      state.loading = true;
      const table = "teachers";
      const res = await SearchService.searchName(table, state.name).catch(
        (err) => {
          console.log(err);

          state.loading = false;
          state.error = true;
        }
      );
      const data = await res.data.results;
      console.log("data: ", data);
      commit("teacherSearchResults", data);
      state.loading = false;
    },
    async GET_SCHOOLS_BY_NAME({ state, commit }) {
      state.error = false;
      state.loading = true;
      const table = "schools";
      const res = await SearchService.searchName(table, state.name).catch(
        (err) => {
          console.log(err);
          state.loading = false;
          state.error = true;
        }
      );

      const data = await res.data.results;
      commit("schoolSearchResults", data);
      state.loading = false;
    },
    async GET_STUDENTS_BY_GROUP({ state, commit }) {
      state.error = false;
      state.loading = true;
      const res = await SearchService.searchStudentsGroup(state.group).catch(
        (err) => {
          console.log(err);
          state.loading = false;
          state.error = true;
        }
      );
      const data = await res.data.results;
      commit("studentGroupSearchResults", data);
      state.loading = false;
    },
    async GET_TEACHERS_BY_GROUP({ state, commit }) {
      state.error = false;
      state.loading = true;
      console.log("Searching for teachers in group: ", state.group);
      const res = await SearchService.searchTeachersGroup(state.group).catch(
        (err) => {
          console.log(err);

          state.loading = false;
          state.error = true;
        }
      );
      const data = await res.data.results;
      console.log("data: ", data);
      commit("teacherGroupSearchResults", data);
      state.loading = false;
    },
    async RESET_SEARCH_STATE({ commit }) {
      await commit("resetSearch");
    },
  },
  getters: {
    getGeo: (state) => state.geo,
    getStudentSearchResults: (state) => state.studentSearchResults,
    getTeacherSearchResults: (state) => state.teacherSearchResults,
    getSchoolSearchResults: (state) => state.schoolSearchResults,
    getPrimarySchoolSearchResults: (state) => state.primarySchoolSearchResults,
    getStudentGroupSearchResults: (state) => state.studentGroupSearchResults,
    getTeacherGroupSearchResults: (state) => state.teacherGroupSearchResults,
    getLoading: (state) => state.loading,
    getError: (state) => state.error,
  },
};

export default searches;
